import { aawzDate } from '@utils/dates/aawz-date'

// Datas padrão ao criar uma tarefa manual pré-preenchida: início hoje, entrega em +dueDays dias.
export const buildDefaultTaskDates = (dueDays = 7) => {
  const today = aawzDate(new Date()).format('DD/MM/YYYY')
  const dueDate = aawzDate(new Date()).add(dueDays, 'days').format('DD/MM/YYYY')
  return { startDate: today, dueDate }
}
